import { Assets, Texture } from "pixi.js";

export type StickTextures = {
  default: Texture;
  melt: Texture;
  moreMelt: Texture;
  charcoal: Texture;
  fire: Texture[];
  respawn: Texture[];
};

export type TextureList = {
  player: Texture[];
  npc: Texture[];
  fire: Texture[];
  fireBase: Texture;
  sticks: StickTextures;
};

export async function loadTexturesFromSpritesheet(): Promise<TextureList> {
  const sheet = await Assets.load("/spritesheet.json");

  const player = sheet.animations["walk"];
  const npc = sheet.animations["npc-walk"];
  const fire = sheet.animations["fire"];
  const fireBase = sheet.textures["base.png"];

  const sticks: StickTextures = {
    default: sheet.textures["stick2.png"],
    melt: sheet.textures["stick3.png"],
    moreMelt: sheet.textures["stick4.png"],
    charcoal: sheet.textures["stick7.png"],
    fire: sheet.animations["stick-fire"],
    respawn: sheet.animations["stick-respawn"],
  };

  return {
    player,
    npc,
    fire,
    fireBase,
    sticks,
  };
}
